import React, {useState, useMemo, useEffect} from "react";
import AllProductContext from "./AllProductsContext";

const AllProductState = (props) => {
  const [state, setState] = useState([]);

  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state]
  );
  useEffect(() => {
    //console.log("all prod state:", state);
  }, [state]);
  return (
    <AllProductContext.Provider value={value}>
      {props.children}
    </AllProductContext.Provider>
  );
};

export default AllProductState;
